module.exports = __webpack_public_path__ + "static/media/self.d378bdfb.jpg";